// ============================================================================
// AttachmentParts — vignette d'une piece jointe (editeur + apercu)
// ============================================================================
// Partagee par la liste de l'editeur (AttachmentsField) et le rendu dans le
// telephone (PhoneAttachments) : une image se montre en vignette, un document
// en pastille d'icone teintee (Lucide, tokens). La legende vit dans
// attachmentLabels.ts.

import { FileText, Image as ImageIcon, Presentation } from 'lucide-react';
import type { AttachmentKind, AttachmentView } from './piecesJointes';

const TILE: Record<AttachmentKind, string> = {
  image: 'bg-blue-50 text-blue-600 dark:bg-blue-950/40 dark:text-blue-400',
  pdf: 'bg-red-50 text-red-600 dark:bg-red-950/40 dark:text-red-400',
  pptx: 'bg-amber-50 text-amber-600 dark:bg-amber-950/40 dark:text-amber-400',
};

/** Vignette (image) ou pastille d'icone (document), carree. */
export function AttachmentTile({ attachment, size = 'md' }: { attachment: AttachmentView; size?: 'sm' | 'md' }) {
  const box = size === 'sm' ? 'h-9 w-9' : 'h-11 w-11';
  if (attachment.kind === 'image' && attachment.url) {
    return (
      <img
        src={attachment.url}
        alt=""
        className={`${box} shrink-0 rounded-lg border border-slate-200 object-cover dark:border-slate-700`}
      />
    );
  }
  const Icon = attachment.kind === 'pdf' ? FileText : attachment.kind === 'pptx' ? Presentation : ImageIcon;
  return (
    <span className={`${box} flex shrink-0 items-center justify-center rounded-lg ${TILE[attachment.kind]}`}>
      <Icon size={size === 'sm' ? 16 : 18} aria-hidden />
    </span>
  );
}
